import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import PageHelmet from "../components/PageHelmet.jsx";
import CustomDataGrid from "../components/CustomDataGrid.jsx";
import { MdArrowBackIos } from "react-icons/md";
import {
    generateGridRows,
    generateGridColumns,
    existingPaymentsGridColumns,
    paymentsRowMapping,
    generateFormData,
    paymentsMapping
} from "../utils/PageUtils.js";
import EntityDetails from "../components/EntityDetails.jsx";
import '../styles/Activities.css';
import { fetchPayments } from "../utils/api";

function Payments({ userRole, bearerToken }) {
    const [payments, setPayments] = useState([]);
    const [paymentError, setPaymentError] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (selectedPayment && isMobile) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [selectedPayment, isMobile]);

    const handleClosePaymentDetails = () => {
        setSelectedPayment(null);
        setSelectedRowId(null);
    }

    useEffect(() => {
        const fetchPaymentsDetails = async () => {
            try {
                const response = await fetchPayments(bearerToken);
                if (response.success) {
                    setPayments(response.data.records);

                } else {
                    setPaymentError(response.message || "Failed to fetch payments");
                }

            } catch (error) {
                setPaymentError("Unable to fetch Payments");
            }
        }
        fetchPaymentsDetails();
    }, []);

    const existingActivitiesRows = generateGridRows(payments, paymentsRowMapping);
    const existingActivitiesColumns = generateGridColumns(existingPaymentsGridColumns, 'description');
    const activityAdditionalDetails = selectedPayment ? generateFormData(selectedPayment, paymentsMapping) : null;

    const handleRowClick = (params) => {
        setPaymentError(null);
        console.log("Row clicked:", params);
        if (selectedRowId === params.id) {
            setSelectedRowId(null);
            setSelectedPayment(null);
            return;
        }
        const activity = payments[params.id - 1];
        setSelectedPayment(activity);
        setSelectedRowId(params.id);

    }

    if (userRole !== "customer" && userRole !== "admin") {
        return (
            <div className="user-error">
                <h1>404 - Page Not Found</h1>
                <p>The page you're looking for doesn't exist.</p>
            </div>
        );
    }
    return (
        <div style={{ margin: "20px" }}>
            <PageHelmet
                title="Payments"
                description="Payments history"
                url={`${process.env.REACT_APP_COGNITO_REDIRECT_URL}/payments`}
            />
            {paymentError && (
                <div >
                    <Alert variant="danger">{paymentError}</Alert>
                </div>
            )}
            {
                !paymentError && (
                    <div className={`activities-container ${selectedPayment ? 'with-details' : 'centered'}`}>
                        <div className="activity-datagrid">
                            <h3 className="title-color">Payments</h3>

                            <CustomDataGrid
                                rows={existingActivitiesRows}
                                columns={existingActivitiesColumns}
                                totalRows={existingActivitiesRows.length}
                                onRowClick={handleRowClick}
                                selectedRowId={selectedRowId}
                            />
                        </div>


                        {/* Desktop details */}
                        {!isMobile && selectedPayment && (
                            <div className="activity-details">
                                <h3 style={{ fontWeight: "bolder" }}>Payment Details</h3>
                                <EntityDetails inputs={activityAdditionalDetails} width={'110px'} />
                            </div>
                        )}

                        {/* Mobile full-screen details */}
                        {isMobile && selectedPayment && (
                            <div className="activity-details mobile-open">
                                <div className="activity-details-header">
                                    <div className="mobile-detail-nav">
                                        <button className="back-btn" onClick={handleClosePaymentDetails} aria-label="Back">
                                            <MdArrowBackIos size={18} />
                                        </button>
                                        <div className="mobile-activity-title">{selectedPayment?.description || selectedPayment?.id || 'Payment'}</div>
                                    </div>
                                </div>
                                <div className="activity-details-body">
                                    <EntityDetails inputs={activityAdditionalDetails} width={'128px'} />
                                </div>
                            </div>
                        )}
                    </div>
                )}
        </div>
    )
}

export default Payments;